import {
  PageBlueprint,
  SubPageBlueprint,
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import {
  documentationRouteRef,
  rootRouteRef,
  usageAnalyticsRouteRef,
} from './routes';

const aiToolsPage = PageBlueprint.make({
  params: {
    path: '/ai-tools',
    title: 'AI Tools',
    icon: <EmojiObjectsIcon />,
    routeRef: rootRouteRef,
  },
});

const documentationPage = SubPageBlueprint.make({
  name: 'documentation',
  attachTo: { id: 'page:ai-tools', input: 'pages' },
  params: {
    path: 'documentation',
    title: 'Documentation',
    routeRef: documentationRouteRef,
    async loader() {
      const { DocumentationPage } = await import('./features/documentation');
      return compatWrapper(<DocumentationPage />);
    },
  },
});

const usageAnalyticsPage = SubPageBlueprint.make({
  name: 'usage-analytics',
  attachTo: { id: 'page:ai-tools', input: 'pages' },
  params: {
    path: 'usage-analytics',
    title: 'Usage Analytics',
    routeRef: usageAnalyticsRouteRef,
    async loader() {
      const { UsageAnalyticsPage } = await import('./features/usage-analytics');
      return compatWrapper(<UsageAnalyticsPage />);
    },
  },
});

export const aiToolsPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'ai-tools',
  extensions: [aiToolsPage, documentationPage, usageAnalyticsPage],
  routes: {
    root: rootRouteRef,
    documentation: documentationRouteRef,
    usageAnalytics: usageAnalyticsRouteRef,
  },
});
